import Vue from 'vue'
import VueRouter from 'vue-router'
import { ADMIN_TOKEN } from '@/utils/cache/cacheKey'
import { getStorage } from '@/utils/cache/localStorage'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/index/Main'),
    redirect: '/index',
    meta: '首页',
    children: [
      { path: 'index', component: () => import('@/views/index/Index'), meta: '首页' } // 首页
    ]
  },
  {
    path: '/setting',
    name: 'setting',
    component: () => import('@/views/index/Main'),
    meta: '系统管理',
    children: [
      // 系统设置
      { path: 'app', component: () => import('@/views/setting/app'), meta: 'APP管理' }, // 基础设置
      { path: 'basicSet', component: () => import('@/views/setting/basicSet'), meta: '基础设置' }, // 基础设置
      { path: 'handleLog', component: () => import('@/views/setting/log'), meta: '日志管理' }, // 日志管理
      { path: 'role', component: () => import('@/views/setting/role'), meta: '角色管理' }, // 角色管理
      { path: 'menu', component: () => import('@/views/setting/menu'), meta: '菜单管理' }, // 菜单管理
      { path: 'notice', component: () => import('@/views/setting/notice'), meta: '公告管理' } // 菜单管理
    ]
  },
  {
    path: '/member',
    name: 'member',
    component: () => import('@/views/index/Main'),
    meta: '账户管理',
    children: [
      // 账户管理
      { path: 'agent', component: () => import('@/views/member/agent'), meta: '代理商' }, // 代理商
      { path: 'underling', component: () => import('@/views/member/underling'), meta: '代理商业务员' }, // 业务员
      { path: 'salesman', component: () => import('@/views/member/salesman'), meta: '平台业务员' } // 业务员
    ]
  },
  {
    path: '/finance',
    name: 'finance',
    component: () => import('@/views/index/Main'),
    meta: '财务管理',
    children: [
      // 财务管理
      { path: 'agentFinance', component: () => import('@/views/finance/agentFinance'), meta: '代理商' }, // 代理商
      { path: 'underlingFinance', component: () => import('@/views/finance/underlingFinance'), meta: '业务员' } // 业务员
    ]
  },
  {
    path: '/insurance',
    name: 'insurance',
    component: () => import('@/views/index/Main'),
    meta: '保险管理',
    children: [
      { path: 'category', component: () => import('@/views/insurance/category'), meta: '保险分类' },
      { path: 'goods', component: () => import('@/views/insurance/goods'), meta: '保险产品' },
      { path: 'packing', component: () => import('@/views/insurance/packing'), meta: '保险包装' },
      { path: 'hot', component: () => import('@/views/insurance/goodshot'), meta: '热门产品' }
    ]
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('@/views/index/Main'),
    meta: '保单管理',
    children: [
      { path: 'allOrder', component: () => import('@/views/order/allOrder'), meta: '所有订单' },
      { path: 'unhandle', component: () => import('@/views/order/unHandle'), meta: '未处理' },
      { path: 'finished', component: () => import('@/views/order/finished'), meta: '已出正本' },
      { path: 'canceled', component: () => import('@/views/order/canceled'), meta: '已注销' },
      { path: 'update', component: () => import('@/views/order/update'), meta: '修改待审核' },
      { path: 'quit', component: () => import('@/views/order/quit'), meta: '退保待审核' }
    ]
  },
  {
    path: '/insure',
    name: 'insure',
    component: () => import('@/views/index/Main'),
    meta: '投保管理',
    children: [
      { path: 'start', component: () => import('@/views/insure/start'), meta: '开始投保' },
      { path: 'add', component: () => import('@/views/insure/addOrder'), meta: '投保' }
    ]
  },
  {
    path: '/score',
    name: 'score',
    component: () => import('@/views/index/Main'),
    meta: '积分管理',
    children: [
      { path: 'index', component: () => import('@/views/score/index'), meta: '积分列表' }
    ]
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: () => import('@/views/index/Main'),
    meta: '充值管理',
    children: [
      { path: 'index', component: () => import('@/views/recharge/index'), meta: '用户充值' }
    ]
  },
  {
    path: '/position',
    name: 'position',
    component: () => import('@/views/index/Main'),
    meta: '位置管理',
    children: [
      { path: 'position', component: () => import('@/views/position/position'), meta: '定位查询' },
      { path: 'travel', component: () => import('@/views/position/travel'), meta: '轨迹查询' }
    ]
  },
  {
    path: '/article',
    name: 'article',
    component: () => import('@/views/index/Main'),
    meta: '文章管理',
    children: [
      { path: 'group', component: () => import('@/views/article/group'), meta: '文章分类' },
      { path: 'list', component: () => import('@/views/article/list'), meta: '文章内容' }
    ]
  },
  {
    path: '/prize',
    name: 'prize',
    component: () => import('@/views/index/Main'),
    meta: '奖品管理',
    children: [
      { path: 'list', component: () => import('@/views/prize/list'), meta: '奖品设置' },
      { path: 'record', component: () => import('@/views/prize/record'), meta: '中奖列表' },
      { path: 'checkin', component: () => import('@/views/prize/checkin'), meta: '签到奖品' },
      { path: 'checkin/record', component: () => import('@/views/prize/checkin/record'), meta: '签到记录' },
      { path: 'task', component: () => import('@/views/prize/task'), meta: '积分任务' }
    ]
  },
  {
    path: '/goods',
    name: 'goods',
    component: () => import('@/views/index/Main'),
    meta: '积分商城',
    children: [
      { path: 'index', component: () => import('@/views/goods/index'), meta: '全部商品' },
      { path: 'order', component: () => import('@/views/goods/order'), meta: '商品订单' }
    ]
  },
  {
    path: '/verify',
    name: 'verify',
    component: () => import('@/views/index/Main'),
    meta: '审核管理',
    children: [
      { path: 'verified', component: () => import('@/views/verify/verified'), meta: '实名认证' },
      { path: 'feedback', component: () => import('@/views/verify/feedback'), meta: '意见反馈' }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/pc/index/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history', // hash
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(function (to, from, next) {
  if (!getStorage(ADMIN_TOKEN)) {
    if (to.path !== '/login') {
      return next('/login')
    }
  }
  next()
})

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// 修改原型对象中的push方法
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
